import client from '../../providers/fetchClient'

export const createProposal = data => client.post('/v3/proposals', data)

export const updateProposal = (id, data) => client.put(`/v3/proposals/${id}`, data)

export const aprovePoposal = (id, data) => client.put(`/v3/proposals/${id}/approve`, data)
